import script from "./ServiceTabView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceTabView.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceTabView.vue?vue&type=style&index=0&id=2e52a978&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e52a978"]])

export default __exports__